module.exports = __webpack_public_path__ + "static/img/newFood7.705b9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood7.png
// module id = Gr/o
// module chunks = 2